<template>
  <div class="cna-attachments-field">
    <span class="cna-attachments-field__label">{{ label }}</span>
    <div class="cna-attachments-field__body">
      <input
        ref="fileInputRef"
        type="file"
        class="cna-attachments-field__input"
        multiple
        @change="handleFileSelect"
      />
      <SecondaryButton
        label="Upload File"
        icon="bi bi-cloud-arrow-up"
        compact
        @click="triggerFileUpload"
      />
      <ul v-if="files.length" class="cna-attachments-field__list">
        <li
          v-for="(file, index) in files"
          :key="`${file.name}-${file.size}-${index}`"
          class="cna-attachments-field__item"
        >
          <i class="bi bi-paperclip" aria-hidden="true"></i>
          <span class="cna-attachments-field__name">{{ file.name }}</span>
          <button
            type="button"
            class="cna-attachments-field__remove"
            aria-label="Remove attachment"
            @click="removeAttachment(index)"
          >
            <i class="bi bi-x" aria-hidden="true"></i>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'CustomerNoteAttachmentsField',
  components: {
    SecondaryButton,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Attachments',
    },
  },
  emits: ['update:modelValue'],
  computed: {
    files() {
      return Array.isArray(this.modelValue) ? this.modelValue : [];
    },
  },
  methods: {
    triggerFileUpload() {
      this.$refs.fileInputRef?.click();
    },
    handleFileSelect(event) {
      const selected = Array.from(event.target.files || []);
      if (!selected.length) return;
      this.$emit('update:modelValue', [...this.files, ...selected]);
      event.target.value = '';
    },
    removeAttachment(index) {
      this.$emit('update:modelValue', this.files.filter((_, i) => i !== index));
    },
    resetInput() {
      if (this.$refs.fileInputRef) {
        this.$refs.fileInputRef.value = '';
      }
    },
  },
};
</script>

<style src="../styles/CustomerNoteAttachmentsField.css"></style>
